export const FREE = 'free';
export const STARTER = 'starter';
export const PROFESSIONAL = 'professional';
export const ENTERPRISE = 'enterprise';